import axiosSecure from '@api/axiosSecure';
import getContextRoot from '@api/getContextRoot';

const cloneWine = async (wineId: number | string): Promise<any> => {
  const res = await axiosSecure.get(`${getContextRoot()}/wine/clone/${wineId}`);
  return res.data;
};

export default cloneWine;
